export default __webpack_public_path__ + "static/media/wand-icon.6a32ed3b.svg";